import Card from "components/card";

type WidgetTone = "brand" | "success" | "warning" | "info" | "purple" | "teal";

const TONE_CLASS: Record<WidgetTone, string> = {
  brand: "bg-surface-muted text-brand-500",
  success: "bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-green-300",
  warning: "bg-warning-50 text-warning-600 dark:bg-warning-500/15 dark:text-amber-300",
  info: "bg-info-50 text-info-600 dark:bg-info-500/15 dark:text-blue-300",
  purple: "bg-purple-50 text-purple-600 dark:bg-purple-500/15 dark:text-purple-300",
  teal: "bg-teal-50 text-teal-600 dark:bg-teal-500/15 dark:text-teal-300",
};

const Widget = (props: {
  icon: JSX.Element;
  title: string;
  subtitle: string;
  tone?: WidgetTone;
}) => {
  const { icon, title, subtitle, tone = "brand" } = props;
  return (
    <Card extra="!flex-row flex-grow items-center rounded-[20px]">
      <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
        <div className={`rounded-full p-3 ${TONE_CLASS[tone]}`}>
          <span className="flex items-center">
            {icon}
          </span>
        </div>
      </div>

      <div className="h-50 ml-4 flex w-auto flex-col justify-center">
        <p className="font-dm text-sm font-medium text-ink">{title}</p>
        <h4 className="text-xl font-bold text-ink">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
